import { Component, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BikeService } from '../../../../services/bike.service';
import { HelpersService } from '../../../../services';
import { NewJobcardService } from '../../../../services/new-jobcard.service';

@Component({
  selector: 'app-workshop-jobcard-search-serial-number',
  templateUrl: './workshop-jobcard-search-serial-number.component.html',
  styleUrls: ['./workshop-jobcard-search-serial-number.component.scss']
})
export class WorkshopJobcardSearchSerialNumberComponent {

  serialNumber: string = '';
  isloading = false;
  resultCount = -1;
  constructor(
    public activeModal: NgbActiveModal, private bikeService: BikeService,
    private helpersService: HelpersService, private newJobcardService: NewJobcardService,
  ) { }

  search() {
    const serialNumber = (this.serialNumber || '').trim();
    if (!serialNumber || this.isloading) {
      return;
    }

    this.bikeService.getItemBySerialNumber(this.helpersService.getPartnerId(), serialNumber).subscribe(res => {
      this.resultCount = -1;
      if (res == null) {
        this.resultCount = 0;
        return;
      }
      // TODO: look up the item + customer by serial number and close with { selectedItem, customer }
      this.activeModal.close({

        customer: {
          ID: res.customer.ID,
          Name: res.customer.Name,
          Surname: res.customer.Surname,
          Email: res.customer.Email,
          PhoneNumber: res.customer.PhoneNumber,
          Locked: false
        },
        selectedItem: {
          bikeID: res.selectedItem.bikeID,
          brand: res.selectedItem.brand,
          model: res.selectedItem.model,
          serialNumber: res.selectedItem.serialNumber,
          color: res.selectedItem.color,
          yearModel: res.selectedItem.yearModel,
          size: res.selectedItem.size,
          locked: false,
          searchedBySerial: true
        }
      });
    });
    
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    event.stopPropagation();
    this.search();
  }


  scheduleService() {
    this.activeModal.close({});
      
  }
}
